import { useEffect, useMemo, useState } from 'react'
import settings from '../../../api/settings/hooks'
import { APPLICATION_SETTINGS, REAL_ESTATE_SERVICE, REAL_ESTATE_TYPES } from '../../../common/constants'
import {
    propertyFlatLeaseViewData,
    propertyFlatSaleViewData,
    propertyGarageLeaseViewData,
    propertyGarageSaleViewData,
    propertyHouseLeaseViewData,
    propertyHouseSaleViewData,
    propertyLandLeaseViewData,
    propertyLandSaleViewData,
    propertyOfficeSpaceLeaseViewData,
    propertyOfficeSpaceSaleViewData,
} from '../../../common/views/propertyViewData'

export const usePropertyGeneralViewData = (propertyType, propertyService, property) => {
    const [viewData, setViewData] = useState()

    const { data: applicationMarket } = settings.GetApplicationSettings.useQuery({
        select: (data) => data.applicationMarket,
    })

    const appSettings = useMemo(
        () => ({
            currency: APPLICATION_SETTINGS.CURRENCY,
            lang: APPLICATION_SETTINGS.DEFAULT_LANGUAGE,
            areaUnit: APPLICATION_SETTINGS.AREA_UNIT,
            applicationMarket,
        }),
        [applicationMarket]
    )

    useEffect(() => {
        if (propertyService && propertyType) {
            switch (parseInt(propertyType)) {
                case REAL_ESTATE_TYPES.flat:
                    if (propertyService === REAL_ESTATE_SERVICE.sale) {
                        setViewData(propertyFlatSaleViewData(property, appSettings))
                    } else if (REAL_ESTATE_SERVICE.lease) {
                        setViewData(propertyFlatLeaseViewData(property, appSettings))
                    }
                    break
                case REAL_ESTATE_TYPES.house:
                    if (propertyService === REAL_ESTATE_SERVICE.sale) {
                        setViewData(propertyHouseSaleViewData(property, appSettings))
                    } else if (REAL_ESTATE_SERVICE.lease) {
                        setViewData(propertyHouseLeaseViewData(property, appSettings))
                    }
                    break
                case REAL_ESTATE_TYPES.officeSpace:
                    if (propertyService === REAL_ESTATE_SERVICE.sale) {
                        setViewData(propertyOfficeSpaceSaleViewData(property, appSettings))
                    } else if (REAL_ESTATE_SERVICE.lease) {
                        setViewData(propertyOfficeSpaceLeaseViewData(property, appSettings))
                    }
                    break
                case REAL_ESTATE_TYPES.land:
                    if (propertyService === REAL_ESTATE_SERVICE.sale) {
                        setViewData(propertyLandSaleViewData(property, appSettings))
                    } else if (REAL_ESTATE_SERVICE.lease) {
                        setViewData(propertyLandLeaseViewData(property, appSettings))
                    }
                    break
                case REAL_ESTATE_TYPES.garage:
                    if (propertyService === REAL_ESTATE_SERVICE.sale) {
                        setViewData(propertyGarageSaleViewData(property, appSettings))
                    } else if (REAL_ESTATE_SERVICE.lease) {
                        setViewData(propertyGarageLeaseViewData(property, appSettings))
                    }
                    break
                default:
                    break
            }
        }
    }, [propertyType, propertyService, property, appSettings])

    return viewData
}
